export const playerIconSvg = `
<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 2.5L27.5 25H2.5L15 2.5Z" fill="#00FFFF" stroke="#FFFFFF" stroke-width="2"/>
    <path d="M15 12.5L21.25 25H8.75L15 12.5Z" fill="rgba(255,255,255,0.5)"/>
    <rect x="12.5" y="25" width="5" height="2.5" fill="#FFFFFF"/>
</svg>
`;
